import { useEffect } from "react"

const useDisableBodyScroll = open => {
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : ""
  }, [open])
}
export default useDisableBodyScroll
